module.exports = __webpack_public_path__ + "img/logo.8fb7aa9f.png";